import { defineStore } from 'pinia';
import { reactive } from 'vue';

export const useOnboardingStore = defineStore('onboarding', () => {
  const state = reactive({
    discoveryMethod: '',
    selectedGenres: [] as string[],
    otherDiscoveryMethodText: '',
    isLoading: false,
  });

  const setDiscoveryMethod = (method: string) => {
    state.discoveryMethod = method;
  };
  const setSelectedGenres = (genres: string[]) => {
    state.selectedGenres = genres;
  };
  const setOtherDiscoveryMethodText = (text: string) => {
    state.otherDiscoveryMethodText = text;
  };

  return { state, setDiscoveryMethod, setSelectedGenres, setOtherDiscoveryMethodText };
});
